import apiClient from './apiClient';
import { cacheUtil, getApiKey, getTeamEmail, getToken } from '../Utility/Utility';

const buildAuthCacheKey = (prefix) => {
  const tokenPart = getToken() || '';
  const apiKeyPart = getApiKey() || '';
  const teamEmailPart = getTeamEmail() || '';
  return `${prefix}:${tokenPart}:${apiKeyPart}:${teamEmailPart}`;
};

const authService = {
  register: async (data) => {
    return apiClient.post('/auth/register', data);
  },
  login: async (data) => {
    return apiClient.post('/auth/login', data);
  },
  teamLogin: async (data) => {
    return apiClient.post('/auth/team-login', data);
  },
  me: async () => {
    const cacheKey = buildAuthCacheKey('auth-me');
    const cached = cacheUtil.get(cacheKey);
    if (cached) {
      return cached;
    }

    const response = await apiClient.get('/auth/me');
    if (response?.success) {
      cacheUtil.set(cacheKey, response, 30 * 1000);
    }
    return response;
  },
  queryTeamMembers: async (data) => {
    return apiClient.post('/auth/team-members/query', data);
  },
  queryRoles: async (data) => {
    return apiClient.post('/auth/roles/query', data);
  },
  createRole: async (data) => {
    return apiClient.post('/auth/roles', data);
  },
  updateRole: async (id, data) => {
    return apiClient.post(`/auth/roles/${id}/update`, data);
  },
  createTeamMember: async (data) => {
    return apiClient.post('/auth/team-members', data);
  },
  updateTeamMember: async (id, data) => {
    return apiClient.post(`/auth/team-members/${id}/update`, data);
  },
  toggleTeamMemberStatus: async (id, data) => {
    return apiClient.post(`/auth/team-members/${id}/toggle-status`, data);
  },
  getApiKeys: async () => {
    return apiClient.get('/auth/api-keys');
  },
  createApiKey: async (data) => {
    return apiClient.post('/auth/api-keys', data);
  },
  onboarding: async (data) => {
    return apiClient.post('/auth/onboarding', data);
  },
  revokeApiKey: async (id) => {
    return apiClient.post(`/auth/api-keys/${id}/revoke`);
  },
  autoTeamOnboard: async (data) => {
    return apiClient.post('/auth/auto-team-onboard', data);
  }
};

export default authService;
